var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamWork2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.35,217.58a393.72,393.72,0,0,0-10.07-41.15C390,137.28,365.6,97.66,323.67,84.34c-30.94-9.83-64.36-3-90.52,17-41,31.39-70.87,74.22-115.76,101.42C79.91,225.46,60.29,262.15,72.9,314s54.68,82.08,100.72,78.36c38.29-3.09,78.31.21,111.41,18.8,29.57,16.6,81.84,2.19,125.07-43.2,25.18-26.44,22.75-60.05,14.54-91.49C419.58,257.11,416.28,237.26,412.35,217.58Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35,217.58a393.72,393.72,0,0,0-10.07-41.15C390,137.28,365.6,97.66,323.67,84.34c-30.94-9.83-64.36-3-90.52,17-41,31.39-70.87,74.22-115.76,101.42C79.91,225.46,60.29,262.15,72.9,314s54.68,82.08,100.72,78.36c38.29-3.09,78.31.21,111.41,18.8,29.57,16.6,81.84,2.19,125.07-43.2,25.18-26.44,22.75-60.05,14.54-91.49C419.58,257.11,416.28,237.26,412.35,217.58Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.8,95.15s4.68-3.69,5.87-6.06c1-2,1.76-4.87.71-7a4,4,0,0,0-5.69-1.83c-2.88,1.79-3.19,7.9-2.45,10.84C141.3,91.33,142.75,95.19,142.8,95.15Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.55,125.93c.19.18,3.53,2.59,3.55,2.54s1.86-5.66,1.55-8.3c-.26-2.25-1.22-5-3.28-6.25a4,4,0,0,0-5.75,1.62C94.2,118.62,97.32,123.88,99.55,125.93Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.56,100.75s-17.12,17.68-17,39.39,17.37,39.24,17.37,39.24,17.13-17.67,17-39.39S197.56,100.75,197.56,100.75Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,153.14a6.75,6.75,0,0,0,.62-.77c1.24-1.89,2.31-4.64,1.51-6.9a4,4,0,0,0-5.44-2.47c-2.33,1.1-3.47,4.83-3.71,7.88-.93-.21-1.77-.37-2.49-.5-.3-.69-.61-1.38-.93-2.08s-.57-1.45-.87-2.19c-.41-1.08-.77-2.22-1.14-3.36,1.35-.6,5.29-2.45,6.76-4.07s3-4.24,2.54-6.59a4,4,0,0,0-5-3.26c-3.26,1-5.17,6.78-5.23,9.81,0,.09,0,.73.11,1.5-.32-1.12-.66-2.24-.95-3.39-.84-3.25-1.59-6.59-2.35-9.93-.16-.69-.33-1.39-.49-2.08,1.14-.51,5.43-2.47,7-4.17s3-4.24,2.54-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.1.06.87.14,1.73-.44-1.81-.9-3.61-1.42-5.38a69.83,69.83,0,0,0-3.2-8.93c.41-.17,5.49-2.37,7.2-4.26,1.51-1.68,3-4.24,2.53-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.21.25,3,.37,4a.42.42,0,0,1,0-.1,52.54,52.54,0,0,0-4.66-8.05,72.79,72.79,0,0,0-5.15-6.54c-1.69-2-3.35-3.62-4.83-5.09-.81-.79-1.57-1.5-2.28-2.15h.07c.06,0-1.58-3.78-1.71-4-1.52-2.62-6-6.79-9.31-6.07A4,4,0,0,0,120,80.86c.74,2.28,3.26,3.81,5.39,4.55s7,.39,8.17.28c.72.7,1.49,1.45,2.32,2.29,1.45,1.5,3.07,3.21,4.71,5.18.44.53.89,1.11,1.33,1.67-.94-.79-2.26-1.84-2.4-1.93-2.55-1.62-8.45-3.26-11.05-1.1a4,4,0,0,0-.07,6c1.7,1.68,4.65,1.88,6.89,1.55s6.5-3,7.41-3.53c1,1.24,1.93,2.55,2.86,4a51.92,51.92,0,0,1,4.43,8c.07.16.12.34.19.5-.4-.47-2.78-2.87-3-3-2.36-1.9-8-4.17-10.87-2.31a4,4,0,0,0-.72,5.93c1.51,1.86,4.41,2.38,6.67,2.3,2.61-.09,7.74-2.68,7.93-2.78a71,71,0,0,1,2.9,8.7c.58,2.19,1.09,4.43,1.57,6.68-.53-.6-2.75-2.83-2.93-3-2.36-1.89-8-4.17-10.87-2.3a4,4,0,0,0-.72,5.93c1.51,1.85,4.41,2.38,6.67,2.3,2.55-.1,7.48-2.56,7.89-2.77l.66,3.08c.69,3.35,1.37,6.71,2.14,10,.27,1.14.57,2.26.87,3.38-.83-.87-2.37-2.42-2.52-2.54-2.36-1.89-8-4.17-10.87-2.3a4,4,0,0,0-.72,5.93c1.51,1.85,4.41,2.38,6.67,2.29s6.46-2.06,7.64-2.63c.51,1.86,1.06,3.69,1.69,5.47.29.76.53,1.56.85,2.27l.48,1.14L161,150s-.05,1.06.05,2.78c-2.49-1.77-6.08-3.3-8.42-2.23a4,4,0,0,0-1.61,5.75,4.12,4.12,0,0,0,.52.72,15.58,15.58,0,0,0,3.22,7.18c.13.14,1.82,1.71,2.7,2.49-.85-.47-1.7-.92-2.58-1.42-1.27-.7-2.59-1.49-3.88-2.25l-2-1.26c-.68-.41-1.28-.89-1.93-1.34-.94-.67-1.88-1.42-2.81-2.16.79-1.26,3.06-5,3.39-7.14s.15-5.18-1.52-6.89a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1.05,11.06,0,.09.45.59.92,1.19-.89-.75-1.78-1.5-2.66-2.3-2.49-2.25-5-4.62-7.44-7l-1.56-1.47c.68-1.05,3.17-5.05,3.52-7.32s.15-5.18-1.52-6.9a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1,11.07.06.09.54.69,1.08,1.36-1.37-1.26-2.75-2.51-4.16-3.7a70.37,70.37,0,0,0-7.59-5.68c.25-.37,3.27-5,3.65-7.52.34-2.24.15-5.18-1.52-6.9a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1,11.07.11.18,1.85,2.35,2.49,3.1l-.09-.06a51.69,51.69,0,0,0-8.33-4.15,72.71,72.71,0,0,0-7.9-2.61c-2.48-.69-4.79-1.17-6.84-1.58-1.11-.21-2.13-.39-3.08-.54l0,0s-3.41-2.29-3.64-2.4c-2.71-1.35-8.75-2.36-11.11.07a4,4,0,0,0,.56,6c1.87,1.49,4.82,1.38,7,.81s6-3.52,7-4.26c1,.18,2,.38,3.2.62,2,.46,4.33,1,6.78,1.73.66.19,1.35.43,2,.65-1.22-.13-2.9-.28-3.06-.28-3,.05-8.85,1.94-9.83,5.18a4,4,0,0,0,3.24,5c2.35.46,4.91-1,6.6-2.5s3.8-6.06,4.23-7c1.5.51,3,1.06,4.58,1.73a51.41,51.41,0,0,1,8.14,4.28c.14.09.29.21.43.31-.59-.17-3.9-.86-4.14-.88-3-.28-9,1-10.34,4.07a4,4,0,0,0,2.67,5.35c2.29.71,5-.45,6.84-1.77,2.12-1.52,5-6.51,5.07-6.7a72.53,72.53,0,0,1,7.22,5.66c1.69,1.5,3.35,3.1,5,4.71-.78-.2-3.86-.85-4.09-.87-3-.28-9,1-10.34,4.08a4,4,0,0,0,2.67,5.34c2.29.71,5-.45,6.84-1.77,2.07-1.48,4.82-6.25,5.05-6.65.75.73,1.5,1.46,2.24,2.2,2.43,2.42,4.85,4.85,7.32,7.17.85.81,1.72,1.57,2.59,2.34-1.17-.27-3.31-.71-3.5-.73-3-.28-9,1-10.34,4.08a4,4,0,0,0,2.67,5.34c2.28.72,5-.45,6.83-1.76s4.25-5.29,4.91-6.41c1.46,1.26,2.93,2.49,4.44,3.63.66.47,1.3,1,2,1.42l1.95,1.3c1.36.85,2.62,1.63,3.91,2.38.64.39,1.26.74,1.9,1.1-1.15-.45-3-1.12-3.15-1.17-2.94-.73-9.05-.42-10.84,2.46a4,4,0,0,0,1.83,5.69c2.15,1.05,5,.31,7-.71,2.23-1.13,5.58-5.27,6-5.78,1.56.89,3.08,1.73,4.52,2.5,3.84,2.06,7.2,3.7,9.8,4.92,8.46,7.32,20.36,8.12,20.36,8.12s.63-14.26-7.76-23.64A29.61,29.61,0,0,0,173.15,153.14Zm-15.1,13.91c.26-.59,2.29-5.12,2.43-7.67l1.4-.29a33,33,0,0,0,5.25,12.55q-2.31-1.09-5-2.44C160.84,168.53,159.46,167.81,158.05,167.05Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.53,150.42s-14.27.43-23,9.51-8.62,23.34-8.62,23.34,14.26-.44,23-9.51S235.53,150.42,235.53,150.42Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.8,95.15s4.68-3.69,5.87-6.06c1-2,1.76-4.87.71-7a4,4,0,0,0-5.69-1.83c-2.88,1.79-3.19,7.9-2.45,10.84C141.3,91.33,142.75,95.19,142.8,95.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.55,125.93c.19.18,3.53,2.59,3.55,2.54s1.86-5.66,1.55-8.3c-.26-2.25-1.22-5-3.28-6.25a4,4,0,0,0-5.75,1.62C94.2,118.62,97.32,123.88,99.55,125.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.56,100.75s-17.12,17.68-17,39.39,17.37,39.24,17.37,39.24,17.13-17.67,17-39.39S197.56,100.75,197.56,100.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,153.14a6.75,6.75,0,0,0,.62-.77c1.24-1.89,2.31-4.64,1.51-6.9a4,4,0,0,0-5.44-2.47c-2.33,1.1-3.47,4.83-3.71,7.88-.93-.21-1.77-.37-2.49-.5-.3-.69-.61-1.38-.93-2.08s-.57-1.45-.87-2.19c-.41-1.08-.77-2.22-1.14-3.36,1.35-.6,5.29-2.45,6.76-4.07s3-4.24,2.54-6.59a4,4,0,0,0-5-3.26c-3.26,1-5.17,6.78-5.23,9.81,0,.09,0,.73.11,1.5-.32-1.12-.66-2.24-.95-3.39-.84-3.25-1.59-6.59-2.35-9.93-.16-.69-.33-1.39-.49-2.08,1.14-.51,5.43-2.47,7-4.17s3-4.24,2.54-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.1.06.87.14,1.73-.44-1.81-.9-3.61-1.42-5.38a69.83,69.83,0,0,0-3.2-8.93c.41-.17,5.49-2.37,7.2-4.26,1.51-1.68,3-4.24,2.53-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.21.25,3,.37,4a.42.42,0,0,1,0-.1,52.54,52.54,0,0,0-4.66-8.05,72.79,72.79,0,0,0-5.15-6.54c-1.69-2-3.35-3.62-4.83-5.09-.81-.79-1.57-1.5-2.28-2.15h.07c.06,0-1.58-3.78-1.71-4-1.52-2.62-6-6.79-9.31-6.07A4,4,0,0,0,120,80.86c.74,2.28,3.26,3.81,5.39,4.55s7,.39,8.17.28c.72.7,1.49,1.45,2.32,2.29,1.45,1.5,3.07,3.21,4.71,5.18.44.53.89,1.11,1.33,1.67-.94-.79-2.26-1.84-2.4-1.93-2.55-1.62-8.45-3.26-11.05-1.1a4,4,0,0,0-.07,6c1.7,1.68,4.65,1.88,6.89,1.55s6.5-3,7.41-3.53c1,1.24,1.93,2.55,2.86,4a51.92,51.92,0,0,1,4.43,8c.07.16.12.34.19.5-.4-.47-2.78-2.87-3-3-2.36-1.9-8-4.17-10.87-2.31a4,4,0,0,0-.72,5.93c1.51,1.86,4.41,2.38,6.67,2.3,2.61-.09,7.74-2.68,7.93-2.78a71,71,0,0,1,2.9,8.7c.58,2.19,1.09,4.43,1.57,6.68-.53-.6-2.75-2.83-2.93-3-2.36-1.89-8-4.17-10.87-2.3a4,4,0,0,0-.72,5.93c1.51,1.85,4.41,2.38,6.67,2.3,2.55-.1,7.48-2.56,7.89-2.77l.66,3.08c.69,3.35,1.37,6.71,2.14,10,.27,1.14.57,2.26.87,3.38-.83-.87-2.37-2.42-2.52-2.54-2.36-1.89-8-4.17-10.87-2.3a4,4,0,0,0-.72,5.93c1.51,1.85,4.41,2.38,6.67,2.29s6.46-2.06,7.64-2.63c.51,1.86,1.06,3.69,1.69,5.47.29.76.53,1.56.85,2.27l.48,1.14L161,150s-.05,1.06.05,2.78c-2.49-1.77-6.08-3.3-8.42-2.23a4,4,0,0,0-1.61,5.75,4.12,4.12,0,0,0,.52.72,15.58,15.58,0,0,0,3.22,7.18c.13.14,1.82,1.71,2.7,2.49-.85-.47-1.7-.92-2.58-1.42-1.27-.7-2.59-1.49-3.88-2.25l-2-1.26c-.68-.41-1.28-.89-1.93-1.34-.94-.67-1.88-1.42-2.81-2.16.79-1.26,3.06-5,3.39-7.14s.15-5.18-1.52-6.89a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1.05,11.06,0,.09.45.59.92,1.19-.89-.75-1.78-1.5-2.66-2.3-2.49-2.25-5-4.62-7.44-7l-1.56-1.47c.68-1.05,3.17-5.05,3.52-7.32s.15-5.18-1.52-6.9a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1,11.07.06.09.54.69,1.08,1.36-1.37-1.26-2.75-2.51-4.16-3.7a70.37,70.37,0,0,0-7.59-5.68c.25-.37,3.27-5,3.65-7.52.34-2.24.15-5.18-1.52-6.9a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1,11.07.11.18,1.85,2.35,2.49,3.1l-.09-.06a51.69,51.69,0,0,0-8.33-4.15,72.71,72.71,0,0,0-7.9-2.61c-2.48-.69-4.79-1.17-6.84-1.58-1.11-.21-2.13-.39-3.08-.54l0,0s-3.41-2.29-3.64-2.4c-2.71-1.35-8.75-2.36-11.11.07a4,4,0,0,0,.56,6c1.87,1.49,4.82,1.38,7,.81s6-3.52,7-4.26c1,.18,2,.38,3.2.62,2,.46,4.33,1,6.78,1.73.66.19,1.35.43,2,.65-1.22-.13-2.9-.28-3.06-.28-3,.05-8.85,1.94-9.83,5.18a4,4,0,0,0,3.24,5c2.35.46,4.91-1,6.6-2.5s3.8-6.06,4.23-7c1.5.51,3,1.06,4.58,1.73a51.41,51.41,0,0,1,8.14,4.28c.14.09.29.21.43.31-.59-.17-3.9-.86-4.14-.88-3-.28-9,1-10.34,4.07a4,4,0,0,0,2.67,5.35c2.29.71,5-.45,6.84-1.77,2.12-1.52,5-6.51,5.07-6.7a72.53,72.53,0,0,1,7.22,5.66c1.69,1.5,3.35,3.1,5,4.71-.78-.2-3.86-.85-4.09-.87-3-.28-9,1-10.34,4.08a4,4,0,0,0,2.67,5.34c2.29.71,5-.45,6.84-1.77,2.07-1.48,4.82-6.25,5.05-6.65.75.73,1.5,1.46,2.24,2.2,2.43,2.42,4.85,4.85,7.32,7.17.85.81,1.72,1.57,2.59,2.34-1.17-.27-3.31-.71-3.5-.73-3-.28-9,1-10.34,4.08a4,4,0,0,0,2.67,5.34c2.28.72,5-.45,6.83-1.76s4.25-5.29,4.91-6.41c1.46,1.26,2.93,2.49,4.44,3.63.66.47,1.3,1,2,1.42l1.95,1.3c1.36.85,2.62,1.63,3.91,2.38.64.39,1.26.74,1.9,1.1-1.15-.45-3-1.12-3.15-1.17-2.94-.73-9.05-.42-10.84,2.46a4,4,0,0,0,1.83,5.69c2.15,1.05,5,.31,7-.71,2.23-1.13,5.58-5.27,6-5.78,1.56.89,3.08,1.73,4.52,2.5,3.84,2.06,7.2,3.7,9.8,4.92,8.46,7.32,20.36,8.12,20.36,8.12s.63-14.26-7.76-23.64A29.61,29.61,0,0,0,173.15,153.14Zm-15.1,13.91c.26-.59,2.29-5.12,2.43-7.67l1.4-.29a33,33,0,0,0,5.25,12.55q-2.31-1.09-5-2.44C160.84,168.53,159.46,167.81,158.05,167.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.53,150.42s-14.27.43-23,9.51-8.62,23.34-8.62,23.34,14.26-.44,23-9.51S235.53,150.42,235.53,150.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "198.27 159.61 212.28 147.01 211.68 146.34 198.26 158.4 198.19 141.9 198.26 141.95 210.12 124.62 209.37 124.11 198.19 140.47 198.01 100.75 197.12 100.75 197.23 127.71 188.31 119.99 187.72 120.67 197.24 128.91 197.32 148.18 183.8 136.22 183.2 136.89 197.32 149.39 197.4 166.94 187.24 158.97 186.69 159.67 197.41 168.09 197.45 179.38 198.35 179.38 198.27 159.6 198.27 159.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.36 164.47 184.47 164.37 183.34 174.34 177.32 167.62 177.34 167.62 175.81 155.54 174.92 155.66 176.28 166.46 161.33 149.74 160.66 150.34 170.81 161.68 164.38 161.76 164.4 162.66 171.6 162.57 178.72 170.52 168.67 170.53 168.67 171.43 179.52 171.42 185.99 178.65 178.9 179.08 178.96 179.97 186.75 179.5 191.06 184.32 191.73 183.72 184.14 175.24 185.36 164.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.22 168.03 231.14 165.6 230.96 164.72 220.3 166.89 235.85 150.73 235.2 150.11 224.65 161.07 224.09 154.67 223.2 154.75 223.82 161.93 216.42 169.62 215.66 159.6 214.76 159.67 215.59 170.49 208.86 177.47 207.91 170.44 207.01 170.56 208.06 178.3 203.58 182.96 204.23 183.58 212.12 175.38 222.96 175.79 222.99 174.9 212.96 174.51 219.21 168.01 219.22 168.03",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.31,
    cy: 124.69,
    rx: 8.47,
    ry: 8.56,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.82,148.11s4-.17,5,6.92,5.18,25.58,5.53,28.17-1.21,5.71-5,6.92-5.88-2.42-6.23-4.15-3.69-22.79-3.69-22.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.89,165.35s-17.52,7.41-17.52,10.1,10.79,29,10.79,29l46.49-12.13-5.21-29.12S237.52,154.57,209.89,165.35Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.87,149.45s-5,3.11-9,5.35-10,5.36-10,11.59,4.5,30.94,4.5,33.53a14.43,14.43,0,0,0,.17,3.46c0-.52,30.42-10.55,30.42-10.55a110.9,110.9,0,0,1,3.46-11.75c1.56-3.8,0-7.09,1.73-13.31s5-10.37,3.63-15-1.73-4.49-6.74-4.67S230.71,147.89,225.87,149.45Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.59,146.73s-2.25,1.21-3.12,6.74a106.71,106.71,0,0,0-.86,13.31s9.33-5.18,10.72-5.36,11.41,4,11.41,4a92.66,92.66,0,0,0-3.46-13.49C236.21,146.38,225.66,144.31,223.59,146.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.86,145.35l.17.59c.67,2.34,3.18,11,4.67,15.31,1.73,5,4.32,7.09,4.32,7.09L233.61,158S223.41,148.11,221.86,145.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,123.22s-8.47-1.38-11.41,9.68,6.57,20.57,9.33,24.2,6.76,4.79,9,1.21c3.46-5.53,4.5-8.3,5-15.56s-.35-12.1-3.63-15.9A11.39,11.39,0,0,0,231,123.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.32,126.85a11.39,11.39,0,0,0-8.3-3.63s-8.47-1.38-11.41,9.68a17.53,17.53,0,0,0,.23,9.53c.31-.79.78-1.41,1.5-1.41,2.07,0,2.25,2.94,2.94,2.77s3.45-2.59,2.94-4.84.17-3.28,3.8-3.28,4.49,1.55,5.7,1.21,2.08-2.77,3.29-2.77a4.07,4.07,0,0,1,2.86,1.32A15.31,15.31,0,0,0,239.32,126.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.28,144.83s-1.39-3.46-2.94-3.81-2.42.7-1.56,3.63,2.08,4.15,2.77,4.15,1-1,1-1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.66,180.26s.86,5.54,4.67,8,9,1.21,9,1.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,168.34s2.42,9.16,1.9,13.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.36,166s2.1.87,3.68,6.3,5.77,15.4,6.82,19.25.7,8.75-3.85,10-9.45-11.2-10.15-12.25-2.45-10.85-1.57-16.1S177.44,165.31,179.36,166Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,184.18s-27.34,26.67-27.34,30.67,16.09,37.08,20.59,36.33,24.75-22.33,24.75-22.33Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.21,170.21a170.25,170.25,0,0,0-14.7,14.7c-6.13,7.17-5.6,19.25-3.68,27.47s5.43,31.5,9.8,32.38,7.88-8.4,15.58-15,13.83-12.25,14.35-16.63-.17-18.37.18-19.42a111,111,0,0,0,1.4-15.58c0-5.07-3.85-10.67-7.7-11.9S156.78,169,155.21,170.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.66,334.83S185,346.47,176.9,353.88s-20.81,16.58-20.81,16.58,13.4,4.24,16.23,4.59,2.11,1.76-1.06,3.18-7.06,2.47-15.88,2.47-14.46,0-14.82-2.12,5.3-7.41,9.53-11.64,20.46-30.7,21.87-32.11S183.25,328.83,190.66,334.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.32,375.05c-2.33-.29-11.82-3.21-15.1-4.23l-2.54,5.64A12.52,12.52,0,0,1,144,373.12c-2.11,2.29-3.63,4.33-3.45,5.46.36,2.12,6,2.12,14.82,2.12s12.7-1.06,15.88-2.47S175.14,375.4,172.32,375.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.88,334.83s5.65,11.64,13.76,19.05,20.82,16.58,20.82,16.58-13.41,4.24-16.23,4.59-2.12,1.76,1.06,3.18,7,2.47,15.87,2.47,14.47,0,14.82-2.12-5.29-7.41-9.53-11.64-20.46-30.7-21.87-32.11S299.29,328.83,291.88,334.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.23,375.05c2.32-.29,11.82-3.21,15.1-4.23l2.54,5.64a12.53,12.53,0,0,0,10.67-3.34c2.1,2.29,3.63,4.33,3.44,5.46-.35,2.12-6,2.12-14.82,2.12s-12.7-1.06-15.87-2.47S307.41,375.4,310.23,375.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16,339.77s4.94,9.17,4.59,12.35c-.29,2.59-6.46,22.37-8.71,29.53a1.8,1.8,0,0,0,1.88,2.33h0a1.8,1.8,0,0,0,1.55-1.24l9.87-30.27s1.76-2.12,7.41-3.17c4.32-.82,25.84-1.83,35.66-2.26a7,7,0,0,1,7.37,6.35c0,.05,0,.09,0,.14.31,4.07,7,25.12,8.52,29.78a1.12,1.12,0,0,0,1.25.76h0a1.12,1.12,0,0,0,.91-1.34c-1.2-5.46-6.35-29-8.21-40.84,0,0-37.4,1.76-45.87-.36a52.9,52.9,0,0,1-14.46-6S108.81,335.54,109.16,339.77Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,277.68S93.29,317.54,95.4,324.6s12.35,16.93,16.23,16.93,7.06-38.8,7.06-42.33S112,283,109.87,277.68,106,277.68,106,277.68Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,337.3c-.13,4-.75,7.06-2.42,7.06-3.17,0-37.75,3.52-45.86,3.17S113.05,343,113.05,337s.35-32.46,6.35-36,37.75-3.88,45.16-3.88c9.12,0,9.51,17.62,9.9,23.59C174.57,322.43,175.64,331,175.44,337.3Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.32,337.65s22.58.71,24.34-2.82,0-10.94-4.58-12.35-23.64-.35-23.64-.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.63,304.49A46.81,46.81,0,0,0,109.87,319c.35,7.77,2.47,15.53,13,21.88s45.16-1.06,45.16-1.06l-2.47-46.22s-22.93-2.82-35.63-.35S112,303.08,111.63,304.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,141.87a28.23,28.23,0,0,0-5.86,9.26c-1.89,5.3-8.13,21.18-7.94,24.2s2.83,6.81,5.48,4.73,9.07-13.23,9.45-13.8.76-8.51.76-13.43S279.22,141.68,277,141.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.1,158.85c2.07-.4,49.34,10,49.34,15.33s-10.67,34.67-10.67,34.67l-45.33-12S277.35,160,283.1,158.85Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.07,135.82s-10.21-1.14-17.4,2.46-7.18,9.64-6.8,15.5,2.33,37.47,2.9,39.74,13.55,1.67,21.11,3.18,12.86-4.73,14-7.19,14.37-26.47,14.37-31.57-5.48-14.75-13.24-19.29A21.93,21.93,0,0,0,299.07,135.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.88 155.29 293.96 159.83 285.83 188.19 287.72 193.67 293.21 189.51 296.23 160.4 300.39 155.86 298.31 150.75 291.88 155.29",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.45,143.57a46,46,0,0,0-2.84,6.62,36.9,36.9,0,0,0-.75,7.56s6.05-2.84,7.75-2.84,5.1,7.76,5.1,7.76,5.11-7.57,5.87-13-5.11-9.45-9.27-9.45A6.69,6.69,0,0,0,292.45,143.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,138.09s1.9-2.84,2.27-.19-1.89,4.72-3.21,5.48a2,2,0,0,1-2.27,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.72,127.12s-1.89-1.51-3,1.51.76,6.81.76,6.81l1.89-4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.72,152.46a1.91,1.91,0,0,0,1.89,2.45c2.46.19,7.56-5.1,7.94-6.24S294.72,152.46,294.72,152.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.61,115.59s-6.62,3-8.13,7.75-4,14.37-4,18,1.13,11,3.59,12.1,10.59-4.16,12.85-5.67,4.92-7.37,7.76-10.78,5.1-9.64,4-14.74S310.22,111.05,303.61,115.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.68,122.21c-1.14-5.11-9.46-11.16-16.07-6.62,0,0-6.62,3-8.13,7.75-.72,2.25-1.65,5.6-2.43,8.89,1.29-2,3.43-5.45,3.56-6.24.19-1.14.19-1.33,1.51-1.33s3.78,3.78,7.19,4.54,7.94.19,7.94,2.08-2.65,4.92-.95,5.86c1.33.74.14,3.29.26,4.4a40,40,0,0,1,3.15-4.59C318.54,133.55,320.81,127.31,319.68,122.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.91,133.93s6.62,3.21,9.83,4.35,6.43,2.45,5.29,4.53-4.91,3-7.18,2.08-1.7-5.67-3-5.86-2.26,2.27-4.72,2.27-5.11-3.78-4.73-6.43S294.91,133.93,294.91,133.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.6,
    y1: 140.92,
    x2: 314.95,
    y2: 136.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.51,
    y1: 133.74,
    x2: 293.77,
    y2: 128.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,173.84S331.77,185,328.52,188.23s-3.4,9.44-.31,10.83,12.85-4.33,14.39-5.57S348.33,174.61,344.31,173.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.66,201.74s16.85,16.84,13.48,22.23-35.71,22.24-35.71,22.24l-6.07-26.28Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.05,172.76s-7.11-.62-9.74,1.08-4.49,17.49-5,26.93-1.7,17-1.08,18.87,16.71,22.13,19,24.92,21.05-25.69,23.68-31.42.93-11-2.48-18.87-10.67-15.17-15-19.19A10,10,0,0,0,354.05,172.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.9,191.48l-.11.6c-.2,1.11-.63,3.65-1,6.52-.47,3.87-.31,9,.93,9s17.48-11.76,17.79-22.43S355.14,187,353.9,191.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.13,170.44s-1.55,5.72-1.55,6.65a20.08,20.08,0,0,0,.62,3.25s-2.63,4.18-2.32,4.64a8.68,8.68,0,0,0,1.23,1.24s-.3,5.88.93,7.12,6.35.46,6.35.46-2.48,3.1.31,3.25,10.21-6,12.38-9.59,2-10.06,0-13.31S357.15,166.41,353.13,170.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.59,159.29s-11.92,1.55-14.08,6.19,2.78,10.37,6.34,11.15a23.18,23.18,0,0,0,5.88.61s-3.71,3.25-1.39,4,3.4.31,3.4,1.08-2.32,3.25-.31,3.41,2.63-3.41,3.87-2.63-.46,3.86.16,4,6.5-6,9-12.54-.93-10.52-3.4-12.68S369.53,158.52,366.59,159.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.59,186.37s2.17-5,3.56-3.86.93,4.64-.62,5.88-4.49-.16-4.49-.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "352.82 199.99 357.77 197.52 357 204.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2,331.42s-8.9,17.52-8.55,20.7c.29,2.59,6.46,22.37,8.72,29.53a1.81,1.81,0,0,1-1.89,2.33h0a1.8,1.8,0,0,1-1.55-1.24l-9.86-30.27s-1.77-2.12-7.41-3.17c-4.33-.82-25.84-1.83-35.67-2.26a7,7,0,0,0-7.36,6.35.66.66,0,0,0,0,.14c-.32,4.07-7,25.12-8.53,29.78a1.12,1.12,0,0,1-1.25.76h0a1.12,1.12,0,0,1-.91-1.34c1.2-5.46,6.35-29,8.22-40.84,0,0,37.39,1.76,45.86-.36s18.43-14.35,18.43-14.35S392.55,327.18,392.2,331.42Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.17,273.33s9.74,40.69,7.11,47.57-13.55,16-17.42,15.7-4.2-39.22-3.94-42.74S391.8,278.17,394.3,273,398.17,273.33,398.17,273.33Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,337.3c.12,4,.75,7.06,2.41,7.06,3.18,0,37.75,3.52,45.87,3.17S384.36,343,384.36,337,384,304.49,378,301s-37.75-3.88-45.16-3.88c-9.12,0-9.52,17.62-9.9,23.59C322.83,322.43,321.77,331,322,337.3Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.84,304.48s-2.92,7.13-2.92,12.79-2.74,16.8-8.4,20.08-12,5.12-21.37,3.84-29.76-4.57-29.76-4.57,21-15,26.29-22.46,7.12-13.69,11.32-17.89S381.47,287.87,381.84,304.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.19,
    cy: 274.43,
    rx: 112.25,
    ry: 86.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.19,
    cy: 271.83,
    rx: 112.25,
    ry: 86.75,
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.81 218.56 326.05 234.19 300.82 252.29 286.28 234.65 311.81 218.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.79 219.91 211.49 231.89 232.13 257.18 256.09 241.21 234.79 219.91",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.12 245.24 246.83 257.22 267.46 282.51 291.42 266.54 270.12 245.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.52 247.08 242.43 254.58 258.07 283.23 284.55 271.92 267.52 247.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.58,205.7s4.53-1.69,4.53-.56,0,2.26-2,2.83-8.77-.85-7.07-1.7A10.15,10.15,0,0,1,237.58,205.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.52,157.1s-5.87,2.07-8.81,5.71-4.32,13.13-5,17.28-3.8,19.88-2.07,21.78,20.22,8.3,23.85,9.34,8,2.59,10.38,2.42a11.33,11.33,0,0,0,4.84-1.9s4.15,1.9,5.18,1.9,2.42-1.9,1.21-3.81-4.58-4.68-6.48-4.68-8.9,1.05-8.9,1.05-11.93-6.05-15.39-8.47a44.11,44.11,0,0,1-6.05-5.18l7.09-22.13",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.6,205.14c-1.9,0-8.9,1.05-8.9,1.05s-1.32-.66-3.2-1.64a8.55,8.55,0,0,0-3.2,4.06,10.19,10.19,0,0,0-.37,2.44l.54.16c3.63,1,8,2.59,10.38,2.42a11.33,11.33,0,0,0,4.84-1.9s4.15,1.9,5.18,1.9,2.42-1.9,1.21-3.81S237.5,205.14,235.6,205.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.43,174.23c-.53.16-4.55,4.55-4.9,9.63s3.5,13.47,4.2,14.87-.17,3.85,1.58,3.85,7.18-8.05,7.18-8.05,6.12.35,6.82-1.22-4.9-10.33-6.12-14S159.41,173.36,156.43,174.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.08,171.61a35.25,35.25,0,0,1-.7,7.17c-.7,2.45-.87,3.68,1.75,7.53a94.39,94.39,0,0,0,8.58,9.8s.35-4,.53-6.3,3.67-3.68,4.37-4.73-3.85-1.75-5.6-4.9-1.75-8.57-4.2-9.1S157,169.16,156.08,171.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.54,160.93s4.9-1.4,4-6.3-9.8-8.57-19.42-7.7-14,7.18-14.88,13.48,5.77,12.42,6.47,13.47-.17,2.1,1.93,2.8a8.08,8.08,0,0,0,4.37,0,4.69,4.69,0,0,0,4.73,1.93c3-.7,2.1-6.65,3.33-7.35s2.1-3,5.77-5.08S179.54,160.93,179.54,160.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.66,175.46s.35-2.8-3.15-3.15-2.62,3-1.92,4.55,3.14,2.8,3.14,2.8.88,4,2.11,4.37,8.57,3.5,10,3,2.8-7,2.8-7,2.45-1.23,2.45-2.45S179,172.83,179,172s1.93-3.33,2.28-5.25-1.75-5.78-1.75-5.78-.88,3.15-3.68,3.15a21.67,21.67,0,0,1-5.6-.87s1.4,3.67.35,5.25-2.8,1.22-3.15,1.92-.17,3.85-.35,4.55S165.71,178.08,164.66,175.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,194.53s.87,7,2.62,9.8,9.1,13.65,9.1,13.65-.52,3.68,0,4.73a48.25,48.25,0,0,1,2.63,6.82c0,.7,1.4,1.23,1.57.18a17.58,17.58,0,0,0,.18-2.45l3,4.55s1.58,1.22,2.1.17.18-6.65.53-8.92-1.4-5.43-2.8-6.83-3.15-3.85-3.68-4.37-2.8-8.75-3.85-14.35-3.85-9.1-5.95-9.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.81,232c.53-1,.18-6.65.53-8.92s-1.4-5.43-2.8-6.83a41.43,41.43,0,0,1-2.85-3.37,11.43,11.43,0,0,0-5.47,3.44l1.14,1.68s-.52,3.68,0,4.73a48.25,48.25,0,0,1,2.63,6.82c0,.7,1.4,1.23,1.57.18a17.58,17.58,0,0,0,.18-2.45l3,4.55S202.29,233,202.81,232Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63,187.53a12.9,12.9,0,0,0-4.55,7.18c-1.22,4.9,2.8,24.85,3.85,30.62s6.3,25,7.88,26.25,19.95-1.05,26.6-2.27,21-6.3,24-7.18,4.55-5.42,5.42-6.3,2.8-3.85,1.75-4.9-4,0-5.25,0-3.5-.17-5.95-.17a5.57,5.57,0,0,0-5.25,4.2,10.36,10.36,0,0,1-1.75,3.67s-18,2.45-21.87,2.45a61.24,61.24,0,0,1-7.53-.52s-2.1-12.08-3.68-19.6-3-13.3-4.2-15.23",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.31,230.93c-1.22,0-3.5-.17-5.95-.17a5.57,5.57,0,0,0-5.25,4.2,10.36,10.36,0,0,1-1.75,3.67l-1.27.17a9.63,9.63,0,0,1,.92,3.33,18.56,18.56,0,0,1-.23,3.78c5.18-1.64,10-3.31,11.61-3.78,3-.87,4.55-5.42,5.42-6.3s2.8-3.85,1.75-4.9S200.54,230.93,199.31,230.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,263.91s4.51.37,6,.37,11.84-1.12,10.34-2.81-12.8-3.2-12.8-3.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.01 253.76 177.14 268.98 189.91 294.9 222.22 278.56 210.01 253.76",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,262.4s3.94,0,4.88.57,4.88,4.13,5.45,3.19-1.69-3.19-2.63-4.13-1.88-1.69-1.88-1.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.15,249.45,191,258.27l-5.3,7.76-35.63-4.23S141.62,250.16,157.15,249.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.19,250.93s-8.25,7-11,15.5-4.5,25.5-4.5,25.5-8.75,12.5-8.75,13.75,7.25,0,7.25,0l-7,12s0,10,5.5,15.25a23.47,23.47,0,0,0,19.25,6.25c6-1,17-14.5,18.25-15.25s-3-12.25-4-16.5,1-7.25,2.25-8,8.5-5.25,10-8.5,1.25-8.75.75-13-6.75-19-12.25-23.5S138.44,246.93,133.19,250.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19,249.68s-3.75,5.5-3.75,9.5,3.25,10.5,5.75,13.5a51.33,51.33,0,0,0,4.75,5l5.5-1.25.25,4.25s1.25-2.25,4.75-.75,5.75.5,5.75-.25a30.78,30.78,0,0,0,0-14.75c-2-8.75-4.25-10.25-7.5-13.5S142.94,246.93,138.19,249.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,250.93s-2.75,4.75-1.25,8.5,6.25,8.25,10,11.5,8.5,6.75,8.5,6.75a21.54,21.54,0,0,0-1.75-16.75C151.44,251.93,142.94,249.18,140.69,250.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.44,228.18a37.42,37.42,0,0,1,1.75,5v1.75s3.5,2,3,2.75-2.5,4-2.5,4a31.94,31.94,0,0,1-.25,8.25c-.75,3.25.25,4.75-2.5,4.75h-7s-.75,10.5-2.5,10.5-9.75-3.75-11.25-5.75-2-4-1.5-5.5a117.79,117.79,0,0,0,4-12.25c1-4.5,8.5-8,10.25-8.75S162.44,228.18,162.44,228.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.69,245.93s-6-1-9-.5-6.75,4.75-6.75,9,3.25,6.75,8.5,7.25,8.75-4,8.75-6.5A29.11,29.11,0,0,0,134.69,245.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.94,244.68s9.5-10.25,12.5-16.5,2-12.75-2.75-12.75-10-1.5-19,1.75-12.75,13.75-12.25,19.25,8.75,16.75,13,17.5,4.25-6.75,4.25-6.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,246.43s-2.25-5-5-3.5-.25,7,1.5,8.25,4.5-.75,4.5-.75",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.19,234.93s-1,3.25-2.25,3.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,280.2s-1.92-1.28-2.17.38,1.66,3.45,1.66,3.45-2.43-2.68-2.56-1.15,1.41,3.2,1.41,3.2-1.92-.9-1.92-.13,2.69,3.45,2.81,4.72,2.56-2.68,3.07-5.74A4.88,4.88,0,0,0,183.36,280.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.69,299.18a41.22,41.22,0,0,0,1.25-6.75c0-2,2.25-5.5,3.25-7.5s-3.25-5.5-1.25-6.5,3.5,1,5.25,3.25,2.25,7,.75,10.25a33.54,33.54,0,0,1-5.5,8.25,11.1,11.1,0,0,1-2.5,2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.58,294.38v-6.33c0-3.17,1.78-7.85,1.78-7.85a1.78,1.78,0,0,1,1.95,2.25,22.15,22.15,0,0,0,.37,6.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19,290.68s-3.5,5-1.75,10.5,26.75,38.75,30.25,38.75,28.75-32.75,30.25-34.75-5-7-5-7l-25.25,23s-6.75-27-9.5-32-9.25-5.5-9.25-5.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.1,184.76s3.45-3.8,7.08-4.5,5.53,1.73,4.5,6.05-4.32,5.36-6.23,5.19-5-1-5.87-3.28A3.05,3.05,0,0,1,247.1,184.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.17,183.72s-7.43,1-9.16,2.25-5.71,7.95-5.71,8.81,2.42,1.73,3.63,1.73,4.33-4.15,4.33-4.15l-1.56,4.33s1.56-.18,1.73-.87,2.59-5.36,2.59-5.36,4.5.18,5.71-1.9S252.8,185.1,249.17,183.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.09,172.31s-2.08,7-2.08,11.34S265,202,265,202a13.61,13.61,0,0,1-3,6.43c-2.46,2.65-1.7,6.24-.57,7.37s3.41,3.22,4.16,1.89.19-3.78.95-4.72,3.59-2.46,4-5.3-.19-11.53-.19-16.26,2.46-11.72-.19-16.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.55,199.76c-3.07-.61-4.76.43-5.66,1.55.09.43.15.68.15.68a13.61,13.61,0,0,1-3,6.43c-2.46,2.65-1.7,6.24-.57,7.37s3.41,3.22,4.16,1.89.19-3.78.95-4.72,3.59-2.46,4-5.3A65.85,65.85,0,0,0,270.55,199.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.81 199.53 257.66 220.14 276 233.19 293.58 210.88 275.81 199.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.87,208s.19,6.43.19,7.38,2.08,2.08,2.27-.19a25,25,0,0,1,.38-3.78c.19-.57,1.32-4.16-.19-6.81",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.92,157.94s-5.1,5.67-7.56,11-4.35,18.9-4.35,18.9-9.83,16.07-11.16,17.4-.56,1.13-3.78,2.64-7.37,2.27-7.94,3.22-2.65,5.48-3.21,6.05.75,1.7,1.51.94,3.4-3.78,3.4-3.78l-3.21,7.56a1,1,0,0,0,1.13.95,15.68,15.68,0,0,0,4-1.32s3.22-.76,4.35-2.27,5.3-9.65,5.3-9.65,11-7,14.93-11.72a43.31,43.31,0,0,0,7.19-12.48c.56-1.89,7.56-22.87,7.37-26.28s-1.89-4-1.89-4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.29,205.81c-.62.71-.6.81-3.22,2-3.21,1.52-7.37,2.27-7.94,3.22s-2.65,5.48-3.21,6.05.75,1.7,1.51.94,3.4-3.78,3.4-3.78l-3.21,7.56a1,1,0,0,0,1.13.95,15.68,15.68,0,0,0,4-1.32s3.22-.76,4.35-2.27,5.3-9.65,5.3-9.65.68-.43,1.78-1.16A7.78,7.78,0,0,0,295.29,205.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3,211.75s-4.18,7.89-4.95,11-2,6.5-2,6.5-7.74-1.24-14.39-2-16.09-2.48-18.42-2.94-6.65-1.71-7.58-.93-.31.62.78,1.08a5.88,5.88,0,0,0,2.78.16s-1.55.46-3.25,1.08-4.8,1.7-5.26,2.32.62,2.79,2.32,2.79a30.54,30.54,0,0,1,3.87,0c.93.15,1.39,1.08,4.49,1.08s7.42-2.48,7.42-2.48,14.55,6.66,22.75,8.05,9.44-.46,12.85-3.1,13.3-18.87,12.53-22.12a18.92,18.92,0,0,0-2.48-5.73",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.44,225.86c-4.05-.66-7.6-1.31-8.91-1.57-2.32-.47-6.65-1.71-7.58-.93s-.31.62.78,1.08a5.88,5.88,0,0,0,2.78.16s-1.55.46-3.25,1.08-4.8,1.7-5.26,2.32.62,2.79,2.32,2.79a30.54,30.54,0,0,1,3.87,0c.93.15,1.39,1.08,4.49,1.08s7.42-2.48,7.42-2.48,1.14.52,2.95,1.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.45,187.92s-7.27,3.56-10.06,6-9.75,18.1-9.9,19.18,5.26,1.71,5.88,1.4,11.61-13,14.39-15.17a4,4,0,0,0,1.55-4.79",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.12,209.9a62.11,62.11,0,0,0-6.81,1.85c-1.86.78-6.19,6.35-5.11,6.66s4-3.25,4-3.25a27,27,0,0,0-2.63,4.64c-.31,1.24-.62,4,.62,3.56s3.71-3.87,3.71-3.87,3.09-1.86,5.57-1.86,4.18-4.64,4.18-4.64,2-2,1.24-4.18S312.12,209.9,312.12,209.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.3,208.66a4.09,4.09,0,0,1-3.25-1.4c-1.24-1.54-2,0-2,1.55a2.19,2.19,0,0,0,1.54,2s-2.63,2.48-1.08,3.25a3.13,3.13,0,0,0,3.1-.46",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.7,249s-7.67-1.46-10.41-2-11.69,3.11-14.24,4,0,1.65,2.74,2.19,8.21-.54,8.21-.54-6,2.55-4.56,2.92,4.38-.37,6.94-.55,5.11-2.56,5.11-2.56,12.24,6,13.7,6,3.65-4.38.54-6.21A44,44,0,0,0,370.7,249Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.44,255.73a62.37,62.37,0,0,0-12.6,12.78c-5.3,7.49-6.21,22.64-5.11,27s1.82,9.49,7.12,13,9.13,4.93,18.26,0,13.88-21.36,13-34-8.58-21.37-12.6-22.46S373.44,255.73,373.44,255.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,258.1s-3.29.37-4.93,2.56-1.1,2.92,0,3.47a2.82,2.82,0,0,1,1.27,2s-3.83,6.21-1.82,7.48,10.95-2.92,13.33-6,1.28-8.22-.18-9.68S374,258.1,374,258.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.79,234.37a17.56,17.56,0,0,1-3.65,3.28c-1.46.73-3.28,1.46-1.82,2.56a23,23,0,0,1,2.37,2s-1.83,6-1.09,9.49a3.14,3.14,0,0,0,4,2.56s-.55,9.13-1.28,11.87,2.74,2.55,5.48.91,3.11-8.4,4.2-13.33,7.67-10.77,3.11-16.25S371.79,234.37,371.79,234.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.56,228.16c-6.76-6.94-17-5.3-18.44-4.93,0,0-5.7-1.39-9-.84s-4.53,10-2.52,15.26a8.65,8.65,0,0,0,3.83,4.46c-.33-.29-2.28-2.13-.4-3.59a8.74,8.74,0,0,1,3.86-1.82s-1.59,5.22-.91,6.14c2.78,3.7-9.72,21.15-10.21,20.87,0,0,3.65,2.06,8.22,4.25,10.09,4.85,22-5.5,25.74-14.24C404.71,246.82,407.58,234.34,401.56,228.16Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.24 254.18 294.02 292.75 312.88 301.34 320.01 265.08 303.24 254.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.88 258.17 296.22 290.22 311.89 297.36 317.82 267.22 303.88 258.17",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.01 265.08 345.79 266.34 340.76 303.44 312.88 301.34 320.01 265.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.6 281.56 329.47 281.64 329.66 280.44 327.82 280.31 327.6 281.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.94 289.98 332.24 288.15 329.64 288.03 329.36 289.8 331.94 289.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.34 276.31 327.57 275.02 325.23 274.86 324.99 276.21 327.34 276.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.5 276.37 330.28 276.45 330.47 275.23 328.72 275.11 328.5 276.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.12 284.37 329.02 284.51 329.29 282.78 327.4 282.7 327.12 284.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.65 279.56 333.95 277.77 331.26 277.64 330.99 279.38 333.65 279.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.91 271.02 328.24 271.13 328.58 269.13 326.27 269.01 325.91 271.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.09 271.26 331.4 269.28 329.74 269.19 329.4 271.18 331.09 271.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.71 272.16 325.43 273.73 327.76 273.89 328.04 272.26 325.71 272.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.11 277.59 328.3 277.51 328.01 279.17 329.84 279.3 330.11 277.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.92 272.4 329.2 272.32 328.91 273.97 330.65 274.09 330.92 272.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.8 284.77 333.1 282.96 330.45 282.84 330.18 284.59 332.8 284.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.23 285.18 320.32 285.05 320.07 286.44 321.99 286.53 322.23 285.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.79 287.67 319.87 287.58 319.61 289.11 321.51 289.25 321.79 287.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.31 290.38 319.41 290.25 319.17 291.63 321.07 291.72 321.31 290.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.87 292.86 318.96 292.77 318.69 294.31 320.58 294.45 320.87 292.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.71 282.48 320.78 282.39 320.52 283.91 322.43 284.05 322.71 282.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.63 277.29 321.69 277.2 321.43 278.71 323.36 278.84 323.63 277.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.56 272.1 322.6 272.01 322.34 273.51 324.28 273.64 324.56 272.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.15 279.98 321.23 279.85 320.98 281.25 322.91 281.34 323.15 279.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.08 274.78 322.14 274.64 321.89 276.06 323.83 276.15 324.08 274.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.8 272.58 332.07 272.45 331.8 274.17 334.51 274.36 334.8 272.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.38 295.58 318.5 295.45 318.12 297.57 320 297.76 320.38 295.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.63 281.7 333.28 281.82 333.47 280.7 330.81 280.52 330.63 281.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329 292.08 331.58 292.2 331.76 291.11 329.18 290.93 329 292.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.81 286.89 332.43 287.01 332.61 285.91 330 285.73 329.81 286.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.85 285.64 326.92 285.51 326.7 286.75 328.66 286.84 328.85 285.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.39 293.34 328.83 293.22 328.55 295 331.09 295.18 331.39 293.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.37 296.14 327.99 298.57 330.49 298.82 330.9 296.32 328.37 296.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.51 278.93 326.86 279.09 327.15 277.45 324.79 277.35 324.51 278.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.76 270.96 325.12 268.95 323.15 268.85 322.8 270.88 324.76 270.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.44 276.5 334.14 276.63 334.32 275.5 331.62 275.31 331.44 276.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 271.31 334.99 271.44 335.31 269.48 332.55 269.34 332.25 271.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.48 287.98 326.51 287.88 326.21 289.57 328.21 289.71 328.48 287.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.35 287.83 322.94 287.72 322.66 289.33 325.06 289.49 325.35 287.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.02 290.71 325.81 291.93 327.85 292.03 328.04 290.85 326.02 290.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.67 293.17 325.61 293.07 325.31 294.78 327.4 294.92 327.67 293.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.74 294.53 324.16 294.7 324.45 293.02 322.02 292.91 321.74 294.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.87 290.63 322.46 290.46 322.23 291.77 324.65 291.88 324.87 290.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.15 286.58 325.55 286.69 325.77 285.43 323.38 285.26 323.15 286.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.53 295.66 321.14 297.87 323.57 298.12 323.97 295.83 321.53 295.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.22 296.06 325.12 295.91 324.72 298.24 326.85 298.45 327.22 296.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.67 280.23 324.31 280.06 324.07 281.39 326.45 281.5 326.67 280.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.25 282.64 323.87 282.53 323.58 284.13 325.96 284.29 326.25 282.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35,288.78S372,289,368,292.25s-19.9,31-19.9,31-14.43-9-18.08-11.5-6.57-7.12-8.58-9.86-2.38-3.11-5.12-3.29-4.74-2-5.11-.73.73,1.83,1.46,2.19a5.56,5.56,0,0,0,2,.37,7,7,0,0,1-4.93-1.1c-2.74-1.64-3.47-2-3.47-.18s2,4.75,3.47,6.57,9.86,2.56,9.86,2.56a155.7,155.7,0,0,0,10.23,17c5.47,7.67,17.16,15.89,20.45,14.79s20.63-22.82,25.38-28.85,11-13.15,9.49-17.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.06,306.91c-1.43-1.79-2.66-3.62-3.66-5-2-2.74-2.38-3.11-5.12-3.29s-4.74-2-5.11-.73.73,1.83,1.46,2.19a5.56,5.56,0,0,0,2,.37,7,7,0,0,1-4.93-1.1c-2.74-1.64-3.47-2-3.47-.18s2,4.75,3.47,6.57,9.86,2.56,9.86,2.56.37.72,1,1.89A10.79,10.79,0,0,1,325.06,306.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamWork2);
export default __webpack_public_path__ + "static/media/TeamWork2.d95c52e765b668608375188ab84e900a.svg";
export { ForwardRef as ReactComponent };